import { QUESTION_PROMPT_MAX_LENGTH } from 'containers/QuestionnairePage/constants';
import { getAnswerGoals, getAnswerObjective } from './utils';
import {
  ERROR_CODES_CONVERSATIONAL,
  MAX_GOAL_ANSWERS_CONVERSATIONAL,
} from './constants';

function validate(question) {
  const errors = {};
  const objectiveAnwer = getAnswerObjective(question);
  const goalAnswers = getAnswerGoals(question).filter(
    (answer) => !answer.isEmptyAnswer,
  );

  if (objectiveAnwer) {
    if (objectiveAnwer.body.trim().length === 0) {
      errors[ERROR_CODES_CONVERSATIONAL.objectiveEmpty] = true;
    } else if (objectiveAnwer.body.length > QUESTION_PROMPT_MAX_LENGTH) {
      errors[ERROR_CODES_CONVERSATIONAL.objectiveTooLong] = true;
    }
  }
  if (goalAnswers) {
    if (
      goalAnswers.some(
        (goalAnswer) => goalAnswer.body.length > QUESTION_PROMPT_MAX_LENGTH,
      )
    ) {
      errors[ERROR_CODES_CONVERSATIONAL.goalTooLong] = true;
    }

    if (
      goalAnswers.length <= 1 &&
      goalAnswers.some(
        (goalAnswer) =>
          goalAnswer.isEmptyAnswer || goalAnswer.body.trim().length === 0,
      )
    ) {
      errors[ERROR_CODES_CONVERSATIONAL.noGoals] = true;
    } else if (
      goalAnswers.some((goalAnswer) => goalAnswer.body.trim().length === 0)
    ) {
      errors[ERROR_CODES_CONVERSATIONAL.goalEmpty] = true;
    } else if (
      goalAnswers.filter((answer) => !answer.isEmptyAnswer).length >
      MAX_GOAL_ANSWERS_CONVERSATIONAL
    ) {
      errors[ERROR_CODES_CONVERSATIONAL.tooManyGoals] = true;
    }
  }

  return errors;
}

export default validate;
